// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"f3b8b4b0","275":"b974eb0a","358":"ddb7260c","412":"74dbea48","477":"2b795bd4","651":"3caf25bf","769":"b70f0ed2","830":"6c99b3d7"}[chunkId] + ".chunk.js";
};